export const QueryKey = {
	topCategory: 'topCategory',
	subCategory: 'subCategory',
	childCategory: 'childCategory',
	category: 'category',
};
